<template>
  <validation-observer
      ref="form"
      #default="{ invalid }"
      tag="form"
      class="repeater__form"
      style="overflow: visible"
  >
    <b-modal
        v-model="show"
        content-class="package-modal rounded-8"
        dialog-class="wameed-modal-md"
        no-fade
    >
      <template slot="modal-header-close">
        <close-icon/>
      </template>
      <template slot="modal-title">
        <div class="d-block text-center">
          <h3 class="text-reg-18">
            {{ $t('status.change') }}
          </h3>
        </div>
      </template>


      <div class="text-danger mb-5">
        {{ $t('status.warning_message') }}
      </div>

      <div class="d-flex flex-wrap" style="gap: 12px">
        <div class="status-container clickable"
             @click="changeToActive(status)"
             :class="status.value==activeStatus? 'custom':''"
             v-for="status in filteredStatuses" :style="`--color:#${status.color};--bgColor:${bgColor(status.color)}`">
          <div class="status-container--text text">
            {{ status.name }}
          </div>
        </div>
      </div>

      <template slot="modal-footer">
        <wameed-btn
            classes="  text-med-14 text-white mx-0 rounded-8"
            :title="$t('btn.update')"
            :disabled="invalid"
            type="submit"
            variant="main"
            @onClick="showConfirmModal=true"
        />
        <wameed-btn
            classes="  text-med-14 text-font-secondary mx-0 rounded-8 "
            :title="$t('btn.cancel')"
            type="button"
            variant="gray"
            @onClick="closeModal()"
        />
      </template>


      <warning-modal
          variant="danger"
          iconName='o-warning-danger-icon'
          :visible="showConfirmModal"
          @close="showConfirmModal = false"

          @submitAction="changeStatus"
          :title="$t('status.modal.title')"
          :subTitle="$t('status.modal.desc')"
          :btnTitle="$t('common.change')"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import {WameedBtn,} from 'wameed-ui/dist/wameed-ui.esm';
import {mapActions, mapGetters} from 'vuex';
import WarningModal from "@/components/WarningModal.vue";


export default {
  components: {
    WarningModal,
    ValidationProvider,
    ValidationObserver,
    WameedBtn,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    isInternal: {
      type: Boolean,
      default: false
    },

    order: {
      type: Object,
      default: null,
    },

  },

  data() {
    return {
      showConfirmModal: false,
      activeStatus: '',
      statuses: [
        { name: "قيد المراجعة", value: 'pending', color: 'f0ad4e', is_internal: true }, // Orange
        { name: "جاري الإستلام", value: 'in_recive', color: 'f0ad4e', is_internal: true }, // Orange
        { name: "تم الإستلام بالمخزن", value: 'recieved_in_warehouse', color: '17a2b8', is_internal: true }, // Teal (Info)
        { name: "التأكيد من العميل", value: 'confirmed_by_client', color: 'ffc107', is_internal: true }, // Yellow
        { name: "قيد النقل", value: 'in_transit', color: '007bff', is_internal: false }, // Blue
        { name: "تم استلام الفرع", value: 'recieved_in_branch', color: '6f42c1', is_internal: false }, // Purple
        { name: "الاسناد للموصل", value: 'assigned_to_driver', color: 'fd7e14', is_internal: true }, // Orange-Red
        { name: "جارِ التجهيز", value: 'preparing', color: '20c997', is_internal: true }, // Green-Teal
        { name: "في الطريق إلى التسليم", value: 'out_for_delivery', color: '28a745', is_internal: true }, // Green
        { name: "مقبول", value: 'approved', color: '5cb85c', is_internal: true }, // Green
        // { name: "في الطريق", value: 'in_way', color: '0275d8', is_internal: true }, // Blue
        // { name: "ملغي", value: 'canceled', color: 'dc3545', is_internal: true }, // Red
        // { name: "معلق", value: 'on_hold', color: 'ffc107', is_internal: true }, // Yellow
        // { name: "مرتجع", value: 'refunded', color: '6610f2', is_internal: true }, // Purple
        { name: "تم التوصيل", value: 'completed', color: '6c757d', is_internal: true } // Gray
      ],
      form: {
        note: '',
        reason: null,
      },
      showSuccessModal: false,
    };
  },
  computed: {
    ...mapGetters({
      // getStatues: 'vendor/orders/getStatues',
    }),
    internalOrder() {
      return this.order.from_city_id === this.order.to_city_id;
    },
    filteredStatuses() {
      // For internal orders, show only statuses with is_internal: true
      // For external orders, show all statuses
      return this.internalOrder
        ? this.statuses.filter(status => status.is_internal)
        : this.statuses;
    },
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.activeStatus = 0;
          this.$emit('close');
        }
      },
    },

  },


  methods: {
    ...mapActions({
      cancel: "vendor/orders/cancel",
      update: "vendor/categories/update",
    }),
    changeToActive(status) {
      this.activeStatus = status.value;
    },
    bgColor(color) {
      let rgb = this.hexToRgb('#' + color);
      return `rgba(${rgb.r},${rgb.g},${rgb.b},.1)`
    },
    hexToRgb(hex) {
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    changeStatus() {
      if (this.activeStatus !== 0) {
        this.$store.dispatch('admin/talqahBusiness/orders/changeStatus',
            {order_id: this.order.id, status: this.activeStatus})
            .then(() => {
              this.$emit('onComplete', true);
              this.closeModal();
              this.$store.commit('loadingFinish', null, {root: true});
            });
      }
    },
    closeModal() {
      this.show = false;
      this.activeStatus = 0;
      this.showConfirmModal = 0;
      this.form.note = '';
    },
  },
};
</script>
